import React, { useContext, useEffect } from 'react';

import { GlobalContext } from '../../../../store';

import { RoundResultsSectionSelector } from './Components/RoundResultsSectionSelector/RoundResultsSectionSelector';
import { useResultsSectionSelector } from './useResultsSectionSelector';
import { AdminEventLeaderboard } from '../AdminEventLeaderboard/AdminEventLeaderboard';
import RoundResults from '../RoundResults';

interface IEventResults {
  clubId: number;
  eventId: number;
  roundId: number;
}

const EventResults = (props: IEventResults) => {
  const { clubId, eventId, roundId } = props;

  const { adminRoundFormats } = useContext(GlobalContext);

  const [sectionSelected, onSectionOnClick] = useResultsSectionSelector();

  const sections = {
    Leaderboards: <AdminEventLeaderboard />,
    Scorecards: <RoundResults clubId={clubId} eventId={eventId} roundId={roundId} />
  };

  useEffect(() => {
    const roundFormats = roundId ? adminRoundFormats[Number(roundId)] : null;

    if (!!roundFormats) {
      const isScramble = roundFormats.some(format => format.format.prefix.includes('scramble'));

      if (isScramble) {
        onSectionOnClick('Leaderboards')();
      }
    }
  }, [roundId, adminRoundFormats]);

  return (
    <div className="event-wizard-page round-setup round-results">
      <div className="event-wizard-round-awards">
        <h2>RESULTS</h2>

        <RoundResultsSectionSelector
          onSectionOnClick={onSectionOnClick}
          sectionSelected={sectionSelected}
        />

        {sections[sectionSelected]}
      </div>
    </div>
  );
};

export default EventResults;
